/**
 * Load geojson data from JSON file
 *
 * @param {String} path path to file or url
 * @returns geojson data
 */

export async function getData(path) {
    try {
        const response = await fetch(path);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
    }
}
